const comments = [
  {
    user: '吃瓜一线群众',
    avatar: '吃',
    time: '15分钟前',
    content: '这个爆料太劲爆了！感觉接下来还有更大的瓜要出来，已经搬好小板凳坐等更新。',
    likes: 326,
  },
  {
    user: '娱乐圈观察家',
    avatar: '观',
    time: '28分钟前',
    content: '作为一个关注娱乐圈十年以上的老粉，这次事件的反转程度确实超出预期。建议理性吃瓜，等官方回应。',
    likes: 218,
  },
  {
    user: '今日份快乐源泉',
    avatar: '乐',
    time: '42分钟前',
    content: '每天打开51吃瓜就是我的快乐源泉！今天的更新质量很高，好几条都特别有料。',
    likes: 195,
  },
  {
    user: '深夜吃瓜选手',
    avatar: '夜',
    time: '1小时前',
    content: '熬夜党的最大福利就是能在第一时间看到最新更新。51吃瓜的更新速度真的没话说，全网最快实至名归。',
    likes: 142,
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-secondary-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            吃瓜热评
          </h2>
        </div>

        <div className="space-y-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-600 text-sm font-bold">{comment.avatar}</span>
                </div>
                <div>
                  <span className="text-sm font-semibold text-foreground-800">{comment.user}</span>
                  <span className="text-xs text-foreground-400 ml-2">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-4">
                <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}